// PdfIcon.js
import React from "react";

export const PdfIcon = () => (
  <svg
  xmlns="http://www.w3.org/2000/svg"
  xmlSpace="preserve"
  width={70}
  height={70}
  viewBox="0 0 303.188 303.188"
  // {...props}
>
  <path
    d="M219.821 0H32.842v303.188h237.504V50.525z"
    style={{
      fill: "#e8e8e8",
    }}
  />
  <path
    d="M230.013 149.935c-3.643-6.493-16.231-8.533-22.006-9.451-4.552-.724-9.199-.94-13.803-.936-3.615-.024-7.177.154-10.693.354-1.296.087-2.579.199-3.861.31a93.594 93.594 0 0 1-3.813-4.202c-7.82-9.257-14.134-19.755-19.279-30.664 1.366-5.271 2.459-10.772 3.119-16.485 1.205-10.427 1.619-22.31-2.288-32.251-1.349-3.431-4.946-7.608-9.096-5.528-4.771 2.392-6.113 9.169-6.502 13.973-.313 3.883-.094 7.776.558 11.594.664 3.844 1.733 7.494 2.897 11.139a165.324 165.324 0 0 0 3.588 9.943 171.593 171.593 0 0 1-2.63 7.603c-2.152 5.643-4.479 11.004-6.717 16.161l-3.465 7.507c-3.576 7.855-7.458 15.566-11.815 23.02-10.163 3.585-19.283 7.741-26.857 12.625-4.063 2.625-7.652 5.476-10.641 8.603-2.822 2.952-5.69 6.783-5.941 11.024-.141 2.394.807 4.717 2.768 6.137 2.697 2.015 6.271 1.881 9.4 1.225 10.25-2.15 18.121-10.961 24.824-18.387 4.617-5.115 9.872-11.61 15.369-19.465l.037-.054c9.428-2.923 19.689-5.391 30.579-7.205 4.975-.825 10.082-1.5 15.291-1.974 3.663 3.431 7.621 6.555 11.939 9.164 3.363 2.069 6.94 3.816 10.684 5.119 3.786 1.237 7.595 2.247 11.528 2.886 1.986.284 4.017.413 6.092.335 4.631-.175 11.278-1.951 11.714-7.57.134-1.72-.237-3.228-.98-4.55zm-110.869 10.31a170.827 170.827 0 0 1-6.232 9.041c-4.827 6.568-10.34 14.369-18.322 17.286-1.516.554-3.512 1.126-5.616 1.002-1.874-.11-3.722-.937-3.637-3.065.042-1.114.587-2.535 1.423-3.931.915-1.531 2.048-2.935 3.275-4.226 2.629-2.762 5.953-5.439 9.777-7.918 5.865-3.805 12.867-7.23 20.672-10.286-.449.71-.897 1.416-1.34 2.097zm27.222-84.26a38.169 38.169 0 0 1-.323-10.503 24.858 24.858 0 0 1 1.038-4.952c.428-1.33 1.352-4.576 2.826-4.993 2.43-.688 3.177 4.529 3.452 6.005 1.566 8.396.186 17.733-1.693 25.969-.299 1.31-.632 2.599-.973 3.883a121.219 121.219 0 0 1-1.648-4.821c-1.1-3.525-2.106-7.091-2.679-10.588zm16.683 66.28a236.508 236.508 0 0 0-25.979 5.708c.983-.275 5.475-8.788 6.477-10.555 4.721-8.315 8.583-17.042 11.358-26.197 4.9 9.691 10.847 18.962 18.153 27.214.673.749 1.357 1.489 2.053 2.22-4.094.441-8.123.978-12.062 1.61zm61.744 11.694c-.334 1.805-4.189 2.837-5.988 3.121-5.316.836-10.94.167-16.028-1.542-3.491-1.172-6.858-2.768-10.057-4.688-3.18-1.921-6.155-4.181-8.936-6.673 3.429-.206 6.9-.341 10.388-.275 3.488.035 7.003.211 10.475.664 6.511.726 13.807 2.961 18.932 7.186 1.009.833 1.331 1.569 1.214 2.207zM227.64 25.263H32.842V0h186.979z"
    style={{
      fill: "#fb3449",
    }}
  />
  <path
    d="M126.841 241.152c0 5.361-1.58 9.501-4.742 12.421-3.162 2.921-7.652 4.381-13.472 4.381h-3.643v15.917H92.022v-47.979h16.606c6.06 0 10.611 1.324 13.652 3.971 3.041 2.647 4.561 6.41 4.561 11.289zm-21.856 6.235h2.363c1.947 0 3.495-.546 4.644-1.641 1.149-1.094 1.723-2.604 1.723-4.529 0-3.238-1.794-4.857-5.382-4.857h-3.348v11.027zM175.215 248.864c0 8.007-2.205 14.177-6.613 18.509s-10.606 6.498-18.591 6.498h-15.523v-47.979h16.606c7.701 0 13.646 1.969 17.836 5.907 4.189 3.938 6.285 9.627 6.285 17.065zm-13.455.46c0-4.398-.87-7.657-2.609-9.78-1.739-2.122-4.381-3.183-7.926-3.183h-3.773v26.877h2.888c3.939 0 6.826-1.143 8.664-3.43 1.837-2.285 2.756-5.78 2.756-10.484zM196.579 273.871h-12.766v-47.979h28.355v10.403h-15.589v9.156h14.374v10.403h-14.374v18.017z"
    style={{
      fill: "#a4a9ad",
    }}
  />
  <path
    d="M219.821 50.525h50.525L219.821 0z"
    style={{
      fill: "#d1d3d3",
    }}
  />
</svg>
);

// DocIcon.js
export const DocIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"  
  width={70}
  height={70}>
    <path
      fill="#008bf5"
      fillRule="evenodd"
      d="M168.579 0h173.378l153.1 153.07v293.997c0 35.729-29.233 64.933-64.933 64.933H168.579c-35.7 0-64.933-29.204-64.933-64.933V64.933C103.647 29.203 132.88 0 168.579 0z"
      clipRule="evenodd"
    />
    <path
      fill="#006fc4"
      fillRule="evenodd"
      d="m341.958 0 153.1 153.07H358.491c-9.1 0-16.533-7.403-16.533-16.504V0zM31.193 218.003h352.638c7.813 0 14.251 6.408 14.251 14.251v129.368c0 7.842-6.438 14.28-14.251 14.28H31.193c-7.842 0-14.251-6.438-14.251-14.28V232.254c.001-7.843 6.409-14.251 14.251-14.251z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M169.779 244.413c-19.225 0-34.865 15.641-34.865 34.865v35.348c0 19.225 15.641 34.865 34.865 34.865 19.226 0 34.866-15.641 34.866-34.865v-35.348c0-19.225-15.64-34.865-34.866-34.865zm18.333 70.213c0 10.108-8.224 18.332-18.333 18.332-10.108 0-18.332-8.224-18.332-18.332v-35.348c0-10.108 8.224-18.332 18.332-18.332 10.109 0 18.333 8.224 18.333 18.332v35.348zm44.215-35.348v35.348c0 10.108 8.224 18.332 18.332 18.332 10.109 0 18.333-8.224 18.333-18.332a8.267 8.267 0 1 1 16.533 0c0 19.225-15.641 34.865-34.866 34.865s-34.865-15.641-34.865-34.865v-35.348c0-19.225 15.641-34.865 34.865-34.865 19.226 0 34.866 15.641 34.866 34.865a8.266 8.266 0 1 1-16.533 0c0-10.108-8.224-18.332-18.333-18.332-10.108 0-18.332 8.224-18.332 18.332zM87.494 244.413H60.895a8.266 8.266 0 0 0-8.266 8.266v88.546a8.266 8.266 0 0 0 8.266 8.266h26.599c19.225 0 34.865-15.641 34.865-34.865v-35.348c.001-19.225-15.64-34.865-34.865-34.865zm18.333 70.213c0 10.108-8.224 18.332-18.332 18.332H69.162v-72.013h18.332c10.108 0 18.332 8.224 18.332 18.332v35.349zm255.361 22.342a8.266 8.266 0 1 1-14.172 8.514l-19.513-32.479-19.513 32.479a8.262 8.262 0 0 1-11.343 2.829 8.267 8.267 0 0 1-2.829-11.343l24.042-40.016-24.042-40.016a8.267 8.267 0 0 1 14.172-8.514l19.513 32.479 19.513-32.479a8.267 8.267 0 0 1 14.172 8.514l-24.042 40.016 24.042 40.016z"
    />
  </svg>
);

// ImageIcon.js

export const ImageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="70"
    height="70"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#4CAF50"
      d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 10l2.5-3 2.5 3h-5zM21 19H3V5h18v14z"
    />
  </svg>
);

// DefaultFileIcon.js
export const DefaultFileIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="70"
    height="70"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#9E9E9E"
      d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6l-4-4zM14 6V2.5L18.5 6H14zm-4 14H8v-2h2v2zm0-4h-1v-2h2v2zm0-4H8V9h2v2zm4 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2z"
    />
  </svg>
);

export const ClearIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="70"
    height="70"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#E53935"
      d="M19.707 4.293a1 1 0 00-1.414 0L12 10.586 5.707 4.293a1 1 0 00-1.414 1.414L10.586 12 4.293 18.293a1 1 0 001.414 1.414L12 13.414l6.293 6.293a1 1 0 001.414-1.414L13.414 12l6.293-6.293a1 1 0 000-1.414z"
    />
  </svg>
);

export const XLSXIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="svg-icon"
    style={{
      width: "70",
      height: "70",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden",
    }}
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="#4CAF50"
      d="M968.704 135.168h-430.08v752.64h430.08c15.36 0 26.624-12.288 26.624-26.624V162.816c0-15.36-11.264-27.648-26.624-27.648z"
    />
    <path
      fill="#FFF"
      d="M727.04 270.336h188.416v80.896H727.04zm0 268.288h188.416v80.896H727.04zm0 134.144h188.416v80.896H727.04zm0-268.288h188.416v80.896H727.04zM538.624 270.336h134.144v80.896H538.624zm0 268.288h134.144v80.896H538.624zm0 134.144h134.144v80.896H538.624zm0-268.288h134.144v80.896H538.624z"
    />
    <path
      fill="#2E7D32"
      d="M592.896 996.352 28.672 888.832V135.168l564.224-107.52z"
    />
    <path
      fill="#FFF"
      d="m379.904 696.32-63.488-119.808c-2.048-4.096-5.12-12.288-7.168-24.576H307.2c-1.024 6.144-4.096 14.336-8.192 25.6L235.52 696.32h-99.328L253.952 512l-107.52-184.32h101.376l53.248 110.592c4.096 9.216 8.192 19.456 11.264 30.72h1.024c2.048-7.168 6.144-17.408 11.264-31.744l57.344-109.568h92.16L364.544 509.952 478.208 696.32h-98.304z"
    />
  </svg>
)

export const CSVIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="svg-icon"
    style={{
      width: "70",
      height: "70",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden",
    }}
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="#45B058"
      d="M145.6 0C100.8 0 64 36.8 64 81.6v860.8c0 44.8 36.8 81.6 81.6 81.6h732.8c44.8 0 81.6-36.8 81.6-81.6V324.8L656 0H145.6z"
    />
    <path
      fill="#FFF"
      d="M388.8 691.2c1.6 1.6 3.2 4.8 3.2 8 0 6.4-4.8 11.2-11.2 11.2-3.2 0-6.4 0-8-3.2-11.2-12.8-30.4-22.4-48-22.4-41.6 0-73.6 32-73.6 78.4 0 44.8 32 78.4 73.6 78.4 17.6 0 35.2-8 48-22.4 1.6-1.6 4.8-3.2 8-3.2 6.4 0 11.2 4.8 11.2 11.2 0 3.2-1.6 6.4-3.2 8-14.4 16-35.2 27.2-64 27.2-56 0-99.2-40-99.2-99.2s43.2-99.2 99.2-99.2c28.8 0 49.6 11.2 64 27.2zm108.8 171.2c-28.8 0-51.2-9.6-67.2-24-3.2-1.6-3.2-4.8-3.2-8 0-6.4 3.2-12.8 11.2-12.8 1.6 0 4.8 1.6 6.4 3.2 12.8 11.2 32 20.8 54.4 20.8 33.6 0 44.8-19.2 44.8-33.6 0-49.6-113.6-22.4-113.6-91.2 0-30.4 27.2-52.8 65.6-52.8 24 0 46.4 8 62.4 20.8 1.6 1.6 3.2 4.8 3.2 8 0 6.4-4.8 11.2-11.2 11.2-1.6 0-4.8 0-6.4-1.6-14.4-11.2-32-17.6-49.6-17.6-24 0-40 12.8-40 30.4 0 43.2 113.6 19.2 113.6 91.2 0 27.2-19.2 56-70.4 56zm272-179.2L702.4 848c-3.2 8-9.6 12.8-17.6 12.8h-1.6c-8 0-16-4.8-19.2-12.8l-65.6-164.8c-1.6-1.6-1.6-3.2-1.6-4.8 0-6.4 4.8-12.8 12.8-12.8 4.8 0 9.6 3.2 11.2 8l62.4 160 62.4-160c1.6-4.8 6.4-8 11.2-8 8 0 14.4 6.4 14.4 12.8 0 1.6-1.6 3.2-1.6 4.8z"
    />
    <path
      fill="#349C42"
      d="M960 326.4v16H755.2s-100.8-20.8-97.6-108.8c0 0 3.2 92.8 96 92.8H960z"
    />
    <path
      fill="#FFF"
      d="M657.6 0v233.6c0 25.6 17.6 92.8 97.6 92.8H960L657.6 0z"
    />
  </svg>
)